import React ,{useContext} from "react";
import { exportToPDF } from "./exportUtils"; 
import AuthContext from "../../context/auth/authContext";
import setAuthToken from "../../functions/auth_header";
import { getAppUrl } from "../../functions/getEnv";
import axios from "axios";
import { toast } from "react-toastify";


const ExportPdfButton = ({ formData }) => {

  const authContext = useContext(AuthContext);
  const { user } = authContext;
  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);
  // console.log(user?.name, user?.azureID, user?.userStatus);

  const handleExportPDF = async() => {
    try {
    exportToPDF(
      formData,
      `${formData.firstName}${formData.lastName}_LeloForm.pdf`
    );
     if (localStorage.token) {
      setAuthToken(localStorage.token);
      }
    const response = await axios.post(`${appUrl}/api/dataexport`, {
      user_name: user?.name,
      azure_id: user?.azureID,
      fileName:  `${formData.firstName}${formData.lastName}_LeloForm.pdf`,
      recordCount: 1,
      screen:"Secondary Enrollments Admin Screen ",
      exportType: "pdf", 
      exportStatus: "success" 
    });
    toast.success("Export to PDF initiated successfully");
    // console.log("Export logged successfully:", response.data);
  } catch (error) {
    console.error("Error during export:", error);
    toast.error("An error occurred during PDF export");
  }
  };

  return (
    <button
      className={`btn btn-llac-dark-green`}
      onClick={handleExportPDF}
    >
      Export to PDF
    </button>
  );
};

export default ExportPdfButton;
